import PropTypes from 'prop-types';
import _ from 'lodash';
import React from 'react';

import GridItemRank from "./GridItemRank";
import GridItemPicture from "./GridItemPicture";
import PromoBadge from "./PromoBadge";
import LocalUrlMaker from "../../../lib/LocalUrlMaker";

import {reportGridItemClick} from "../../../Analytics/googleGridAdapter";
import {getClassList} from "../../../Utility/siteConfig";
import GridItemInfoBlock from "./GridItemInfoBlock";
import VendorskuBlock from "./VendorskuBlock";

const isDev = (process.env.NODE_ENV == 'development');

// 2023-11 modernised
export default function GridItem({
  gridId,
  item,
  showRanks = false,
  flavour,
  index = -1, // printed onscreen if showRanks is true; also used for reporting
  gridState = {},
  className,  // LinearProductGrid uses this
  ...props
}) {
  if (!item)
    return null;

  // used by GridItemPicture, GridItemInfo
  const handleClick = (e) => {
    reportGridItemClick({
      e, item,
      flavour: flavour,
      index: index
    });

    // IMPORTANT: do default action for a click (follow the url)
    return true;
  }

  const path = LocalUrlMaker.prefixedPath(item.path);

  const {promos = []} = item;

  // group is present for hover state on links
  className = [
    "grid-item group h-full w-full relative hover:shadow",
    _.includes(item.tags, "suggest") ? 'tag-suggest' : '',
    className
  ];

  className = getClassList({
    key: 'GridItem',
    fallback: 'bg-white',
    base: className
  });

  const innerClasses = getClassList({
    key: 'GridItem.inner',
    fallback: 'border-b-2 border-gray-100 text-gray-500',
    base: "h-full relative"
  });

  return (
    <div className={className} id={`group-${item.id}`}>
      <div className={innerClasses}>

        {promos.map((promo) =>
          <PromoBadge key={promo.type} promo={promo} item={item}/>)}

        {showRanks && <GridItemRank index={index}/>}

        <GridItemPicture item={item} path={path} handleClick={handleClick}/>

        <GridItemInfoBlock item={item}
          path={path}
          handleClick={handleClick}
          gridState={gridState}
          gridId={gridId}
        />
        {item.vendorsku && <VendorskuBlock item={item} />}

        {isDev && <div className="debug"
          style={{position: 'absolute', right: 0, bottom: 0, fontSize: '0.7rem'}}>
            {item.id} {item.pt} n={item.productCount}
        </div>}
      </div>
    </div>
  );
}


GridItem.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  //dispatch: PropTypes.function.isRequired
}
